import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import GenericBody from "../Componentes/GenericBody";
import NavBar from "../Componentes/NavBar";
import Tabela from "../Componentes/Tabela";
import { formatarData } from "../Funcoes/FormatarData";
import GenericHeader from "../Componentes/GenericHeader";
import Filters from "../Componentes/Utils/Filters";
import FilterContainer from "../Componentes/Utils/FilterContainer";
import Stats from "../Componentes/Utils/Stats";
import { formatCPF } from "../Funcoes/FormatCPF";

import useApi from "../hooks/useApi";
const Pendencias = () => {
    const api = useApi();


    const [ loading, setLoading ] = useState( true )

    const tabelaRef = useRef( null );

    const [ pendencias, setPendencias ] = useState([])
    const [ pendenciasFilter, setPendenciasFilter ] = useState([])

    const GetValues = async () => {

        setLoading( true );

        try{

            const { data } = await api.get('/Painel/API/GetPendencias/')
            console.log( data )

            setPendencias( data )
            setPendenciasFilter( data )

        }catch( e ){

            console.log( e )

        }finally{

            setLoading( false )

        }

    }

    useEffect(() => {

        GetValues();

    }, [])

    const motivosList = useMemo(() => [ ...new Set( pendencias.map(( obj ) => obj.MOTIVO ))].sort(), [ pendencias ])
    const obrasList = useMemo(() => [ ...new Set( pendencias.map(( obj ) => obj.CENTRO_CUSTO ))].sort(), [ pendencias ])
    const encList = useMemo(() => [ ...new Set( pendencias.map(( obj ) => obj.ENCARREGADO ))].sort(), [ pendencias ])

    const [ colabName, setColabName ] = useState('')
    const [ cpfColab, setCpfColab ] = useState('')  

    const [ motivosSel, setMotivosSel ] = useState([])
    const [ obrasSel, setObrasSel ] = useState([])
    const [ encSel, setEncSel ] = useState([])

    const handleFilter = useCallback(() => {

        setPendenciasFilter(
            pendencias.filter(( item ) => {

                const nameFilter = !colabName || item.NOME.includes( colabName )
                const cpfFilter = !cpfColab || item.CPF.includes( cpfColab )

                const motivoFilter = !motivosSel.length || motivosSel.some( obj => ( item.MOTIVO || '' ).includes( obj.value ))
                const obraFilter = !obrasSel.length || obrasSel.some( obj => ( item.CENTRO_CUSTO || '' ).includes( obj.value ))
                const encFilter = !encSel.length || encSel.some( obj => ( item.ENCARREGADO || '' ).includes( obj.value ))

                return nameFilter && cpfFilter && motivoFilter && obraFilter && encFilter

            })
        )

    }, [ pendencias, colabName, cpfColab, motivosSel, obrasSel, encSel ])

    useEffect(() => {

        handleFilter();

    }, [ handleFilter ])

    const [ linhasTabela, setLinhasTabela ] = useState( 100 );

    useEffect(() => {

        const element = tabelaRef.current

        if( !element ){

            return;

        }

        const handleScroll = () => {

            const { scrollTop, scrollHeight, clientHeight } = element;

            if( scrollTop + clientHeight >= scrollHeight - 10 ){

                setLinhasTabela((prev) => prev + 100);

            }

        }

        element.addEventListener("scroll", handleScroll);

        return () => {

            element.removeEventListener("scroll", handleScroll)

        }

    }, [])

    return(
        <>
            <NavBar title="PENDÊNCIAS" />
            <GenericBody>
                <GenericHeader>
                    <Filters columns={ 3 } >
                        <FilterContainer
                            type="text"
                            placeholder="COLABORADOR..."
                            valor={ colabName }
                            changeFunc={( valor ) => setColabName( valor )}
                        />
                        <FilterContainer
                            type="text"
                            placeholder="CPF..."
                            valor={ cpfColab }
                            changeFunc={( valor ) => setCpfColab( valor )}
                        />
                        <FilterContainer
                            type="select"
                            placeholder="MOTIVO..."
                            options={ motivosList }
                            optType="obj"
                            changeFunc={( value ) => setMotivosSel( value )}
                        />
                        <FilterContainer
                            type="select"
                            placeholder="CENTRO CUSTO..."
                            options={ obrasList }
                            optType="obj"
                            changeFunc={( value ) => setObrasSel( value )}
                        />
                        <FilterContainer
                            type="select"
                            placeholder="ENCARREGADO..."
                            options={ encList }
                            optType="obj"
                            changeFunc={( value ) => setEncSel( value )}
                        />
                    </Filters>
                    <Stats></Stats>
                </GenericHeader>
                <Tabela loading={ loading } ref={ tabelaRef } >
                    <thead>
                        <tr>
                            <th>MOTIVO</th>
                            <th>PROPÓSITO</th>
                            <th>COLABORADOR</th>
                            <th>CPF</th>
                            <th>CENTRO CUSTO</th>
                            <th>ENCARREGADO</th>
                            <th>DATA</th>
                            <th>VALIDADE</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            pendenciasFilter.slice( 0, linhasTabela ).map(( obj, index ) => (
                                <tr key={ index } >
                                    <td>{ obj.MOTIVO }</td>
                                    <td>{ obj.VALOR }</td>
                                    <td>{ obj.NOME }</td>
                                    <td>{ formatCPF( obj.CPF ) }</td>
                                    <td>{ obj.CENTRO_CUSTO }</td>
                                    <td>{ obj.ENCARREGADO ? obj.ENCARREGADO : '-' }</td>
                                    <td>{ formatarData( obj.DATA ) }</td>
                                    <td>{ formatarData( obj.VALIDADE ) }</td>
                                </tr>
                            ))
                        }
                    </tbody>
                </Tabela>
            </GenericBody>
        </>
    )

}

export default Pendencias;